import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Button, Checkbox, CheckboxChangeEvent, Spin } from "antd";
import Loader from "../../../../core/common/loader";
import CommonSelect from "../../../../core/common/commonSelect";
import {
  ColumnsType,
  FilterConfirmProps,
  FilterDropdownProps,
} from "antd/es/table/interface";
import { Select, Input } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Toast } from "react-bootstrap";
import { route } from "../../../../core/common/selectoption/selectoption";
import { InactivityContext } from "../InactivityContext";

const { Option } = Select;

type Permission = { id: number; name: string };
type Admin = {
  student_id: number;
  gender_name: string;
  admission_status_name: string;
  state_name: string;
  zone_name: string;
  branch_name: string;
  orientation_name: string;
  student_class: string;
  section_name: string;
  summercamp_agent: string;
  academic_year_name: string;
  varna_student_id: string | null;
  SCS_Number: string;
  is_active: boolean;
  academic_year: number;
  gender: number;
  admission_status: number;
  state: number;
  zone: number;
  branch: number;
  orientation: number;
  section: number;
  agent: number;
  button: string;
  name: string;
  no_of_attempts: number;
};

type Agent = {
  id: number;
  username: string;
};

interface Branch {
  branch_id: number;
  name: string;
  label: string;
}

interface Class {
  class_name_id: number;
  name: string;
  label: string;
}

interface AdmissionStatus {
  admission_status_id: number;
  admission_status: string;
}

interface Orientation {
  orientation_id: number;
  name: string;
  label: string;
}

interface Student_tag {
  id: number;
  name: string;
  short_code: string;
}

type SortOrder = 'ascend' | 'descend' | null;

interface SortConfig {
  field: string;
  order: SortOrder;
}

const WizklubStudents = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState(0);
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [agents, setAgents] = useState<Agent[]>([]);
  const [agentsdata, setAgentsdata] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState<string>("");
  const [filteredData, setFilteredData] = useState(admin);
  // const [selectedAgent, setSelectedagent] = useState<Option | null>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [studentTags, setStudentTags] = useState<Student_tag[]>([]);
  const [agentsFilter, setAgentsFilter] = useState<Agent[]>([]);
  // const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedAgentFilter, setSelectedAgentFilter] = useState<string>("");
  // const [selectedClass, setSelectedClass] = useState<string>("");
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [AsignshowCard, setAsignShowCard] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [sortConfigs, setSortConfigs] = useState<SortConfig[]>([]);
  const [classesDropdown, setClassesDropdown] = useState<Class[]>([]);
  const [targetDate, setTargetDate] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [dangerToastMessage, setDangerToastMessage] = useState("");
  const [nextPageNumber, setNextPageNumber] = useState<number | null>(null); // Added nextPageNumber state
  const [previousPageNumber, setPreviousPageNumber] = useState<number | null>(
    null
  ); // Added previousPageNumber state
  // const [selectedBranchName, setSelectedBranchName] = useState<string>("");
  // const [selectedClassName, setSelectedClassName] = useState<string>("");
  const [selectedAgentName, setSelectedAgentName] = useState<string>("");
  const [admissonStatusDropdown, setAdmissionStatusDropdown] = useState<
    AdmissionStatus[]
  >([]);
  const [agentsDropDown, setAgentsDropDown] = useState<Agent[]>([]);

  const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
  const [orientationsDropdown, setOrientationDropdown] = useState<
    Orientation[]
  >([]);
  const [selectedOrientation, setSelectedOrientation] = useState<number>(() => {
    const saved = localStorage.getItem("StudentsselectedOrientation");
    return saved !== null ? Number(saved) : 0;
  });
  useEffect(() => {
    localStorage.setItem(
      "StudentsselectedOrientation",
      selectedOrientation.toString()
    );
  }, [selectedOrientation]);
  const handleClearState = () => setSelectedOrientation(0);
  const [selectedStudentTag, setSelectedStudentTag] = useState<number>(
    Number(localStorage.getItem("wizklub_students_selected_student_tag1")) || 0
  );
  const [selectedPreviousOrientation, setSelectedPreviousOrientation] =
    useState<number>(() => {
      const saved = localStorage.getItem("StudentsselectedPreviousOrientation");
      return saved !== null ? Number(saved) : 0;
    });
  useEffect(() => {
    localStorage.setItem(
      "StudentsselectedPreviousOrientation",
      selectedPreviousOrientation.toString()
    );
  }, [selectedPreviousOrientation]);
  const [selectedIsPOAttended, setSelectedIsPOAttended] = useState<string>(() => {
    return localStorage.getItem('wizklubStudentsselectedIsPOAttended') || "";
  });
  useEffect(() => {
    localStorage.setItem('wizklubStudentsselectedIsPOAttended', selectedIsPOAttended);
  }, [selectedIsPOAttended]);
  const handleClearIsPOAttended = () => {
    setSelectedIsPOAttended("");
  };
  const handleClearPreviousOrientation = () =>
    setSelectedPreviousOrientation(0);
  const [selectedAgentFilter1, setSelectedAgentFilter1] = useState<number>(0);
  const handleClearAgent = () => setSelectedAgentFilter1(0);
  const [scsSearchText, setScsSearchText] = useState("");
  const [nameSearchText, setNameText] = useState("");

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const inactivityContext = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  useEffect(() => {
    localStorage.setItem(
      "wizklub_students_selected_student_tag1",
      selectedStudentTag.toString()
    );
  }, [selectedStudentTag]);
  const handleClearStudentTag = () => setSelectedStudentTag(0);
  const {
    selectedClass,
    setSelectedClass,
    selectedBranch,
    setSelectedBranch,
    selectedBranchName,
    setSelectedBranchName,
    selectedClassName,
    setSelectedClassName,
    wizklubStudentsSelectedAdmissionStatus,
    setWizklubStudentsSelectedAdmissionStatus,
    wizklubStudentsSelectedAdmissionStatusName,
    setWizklubStudentsSelectedAdmissionStatusName,
    wizklubSelectedAgent,
    setWizklubSelectedAgent,
    wizklubSelectedAgentName,
    setWizklubSelectedAgentName,
  } = inactivityContext;

  useEffect(() => {
    if (!checkPermission("view_wizklub_students", "student")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter1,
        selectedClass,
        wizklubStudentsSelectedAdmissionStatus,
        selectedOrientation,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
      fetchBranches().then(setBranches);
      fetchAgentsData();
      fetchAgents();
      fetchClassesDropdown();
      fetchAdmissionStatus().then(setAdmissionStatusDropdown);
      fetchAgentsDropdown();
      fetchOrientationDropdown();
      fetchStudentTag();
    }
  }, [userPermissions]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branchName: string,
    agentName: number,
    className: string,
    admissionStatus: string,
    orientation: number,
    previous_orientation: number,
    scsNumber: string,
    name: string,
    student_tag: number,
    sortConfigs: SortConfig[],
  ) => {
    let apiUrl = `${webApi}/students/wizklub_student/?page=${page}&page_size=${pageSize}`;

    if (searchText) apiUrl += `&search=${searchText}`;
    if (branchName) apiUrl += `&branch=${branchName}`;
    if (agentName) apiUrl += `&wizklub_agent=${agentName}`;
    if (className) apiUrl += `&student_class=${className}`;
    if (admissionStatus) apiUrl += `&admission_status=${admissionStatus}`;
    if (orientation) apiUrl += `&orientation=${orientation}`;
    if (previous_orientation)
      apiUrl += `&previous_orientation=${previous_orientation}`;
    if (scsNumber) apiUrl += `&SCS_Number=${scsNumber}`;
    if (name) apiUrl += `&name=${name}`;
    if (student_tag) apiUrl += `&student_tags=${student_tag}`;
    if(selectedIsPOAttended !== "") apiUrl += `&is_po_attended=${selectedIsPOAttended}`;
    if (sortConfigs.length > 0) {
      const orderingParams = sortConfigs
        .map(({ field, order }) =>
          order === 'descend' ? `-${field}` : field
        )
        .join(',');
      apiUrl += `&ordering=${orderingParams}`;
    }

    const response = await fetch(apiUrl, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchAgents = async () => {
    const resposne = await fetch(
      `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
      options
    );
    const data = await resposne.json();
    setAgents(Array.isArray(data) ? data : []);
  };

  const fetchClassesDropdown = async () => {
    const resposne = await fetch(
      `${webApi}/branches/wizklub_class_names_dropdown/`,
      options
    );
    const data = await resposne.json();
    setClassesDropdown(data);
  };

  const fetchStudentTag = async () => {
    const resposne = await fetch(
      `${webApi}/students/student_tags_dropdown/`,
      options
    );
    const data = await resposne.json();
    setStudentTags(data);
  };

  const fetchOrientationDropdown = async () => {
    const resposne = await fetch(
      `${webApi}/branches/branches_orientation_dropdown/`,
      options
    );
    const data = await resposne.json();
    setOrientationDropdown(data.results);
  };

  const fetchBranches = async () => {
    const response = await fetch(
      `${webApi}/branches/wizklub_branches_dropdown/`,
      options
    );
    const data = await response.json();
    return data;
  };

  const fetchAdmissionStatus = async () => {
    const response = await fetch(
      `${webApi}/students/students_Admission_status_dropdown/`,
      options
    );
    const data = await response.json();
    return data.results;
  };

  const fetchAgentsDropdown = async () => {
    const resposne = await fetch(`${webApi}/user/users_dropdown/`, options);
    const data = await resposne.json();
    setAgentsDropDown(Array.isArray(data) ? data : []);
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branchName: string,
    agentName: number,
    className: string,
    admissionStatus: string,
    orientation: number,
    previous_orientation: number,
    scsNumber: string,
    name: string,
    student_tag: number,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(
          page,
          pageSize,
          searchText,
          branchName,
          agentName,
          className,
          admissionStatus,
          orientation,
          previous_orientation,
          scsNumber,
          name,
          student_tag,
          sortConfigs
        ),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setFilteredData(groupsData.results);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      setCurrentPage(groupsData.current_page_number);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
      setNextPageNumber(groupsData.next_page_number);
      setPreviousPageNumber(groupsData.previous_page_number);
      // Ensure agentsData is an array
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };
  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);

    // fetchData(current, pageSize, searchText,selectedBranch); // Fetch new data based on the updated pagination
  };

  useEffect(() => {
    fetchData(
      currentPage,
      pageSize,
      searchText,
      selectedBranch,
      selectedAgentFilter1,
      selectedClass,
      wizklubStudentsSelectedAdmissionStatus,
      selectedOrientation,
      selectedPreviousOrientation,
      scsSearchText,
      nameSearchText,
      selectedStudentTag
    );
  }, [
    currentPage,
    selectedBranch,
    selectedAgentFilter1,
    selectedClass,
    pageSize,
    wizklubStudentsSelectedAdmissionStatus,
    selectedOrientation,
    selectedPreviousOrientation,
    scsSearchText,
    nameSearchText,
    selectedStudentTag,
    sortConfigs,
    searchText,
    selectedIsPOAttended
  ]);

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter1,
        selectedClass,
        wizklubStudentsSelectedAdmissionStatus,
        selectedOrientation,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
    }
  };

  const agentsOptions = agents.map(
    (agent: { id: { toString: () => any }; username: any }) => ({
      value: agent.id.toString(),
      label: agent.username,
    })
  );

  const [selectedName, setSelectedName] = useState<string | null>(null);
  const [selectedSCSNumber, setSelectedSCSNumber] = useState<string | null>(
    null
  );

  useEffect(() => {
    const applyFilters = () => {
      let filtered = admin;
      if (selectedName && selectedSCSNumber) {
        filtered = filtered.filter(
          (item) =>
            item.name.includes(selectedName) &&
            item.SCS_Number.includes(selectedSCSNumber)
        );
      } else if (selectedName) {
        filtered = filtered.filter((item) => item.name.includes(selectedName));
      } else if (selectedSCSNumber) {
        filtered = filtered.filter((item) =>
          item.SCS_Number.includes(selectedSCSNumber)
        );
      }
      setFilteredData(filtered);
    };
    applyFilters();
  }, [admin]);

  const handleSelect = (
    student_id: any,
    selectedRowKeys: string[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const selectedIds = [...selectedRowKeys];
    const index = selectedIds.indexOf(student_id);
    if (index >= 0) {
      selectedIds.splice(index, 1);
    } else {
      selectedIds.push(student_id);
    }
    setSelectedRowKeys(selectedIds);
  };

  const handleSelectAll = (
    e: CheckboxChangeEvent,
    data: { student_id: any }[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (e.target.checked) {
      const allIds = data.map((item) => item.student_id);
      setSelectedRowKeys(allIds);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const fetchAgentsData = async () => {
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/teammgmt/get_team_members_by_teammgmt/2`,
        options
      );
      const data = await response.json();
      setAgentsDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleAgentChange = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/students/bulk_summer_camp_agents_change/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            student_ids: selectedRowKeys.join(","),
            agent: selectedAgent,
          }),
        }
      );
      const data = await response.json();
      console.log("Agent updated successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setShowCard(false);
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter1,
        selectedClass,
        wizklubStudentsSelectedAdmissionStatus,
        selectedOrientation,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
    } catch (error) {
      console.error("Failed to update agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/agentsaletarget/assign_target_to_agent/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            student_ids: selectedRowKeys.join(","),
            agent: selectedAgent,
            target_date_: targetDate,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setDangerToastMessage(data.message);
        setShowSolidDangerToast(true);
        throw new Error("Failed to assign agent");
      }

      console.log("Agent assigned successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setTargetDate("");
      setAsignShowCard(false);
      fetchData(
        currentPage,
        pageSize,
        searchText,
        selectedBranch,
        selectedAgentFilter1,
        selectedClass,
        wizklubStudentsSelectedAdmissionStatus,
        selectedOrientation,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
    } catch (error) {
      console.error("Failed to assign agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleAgentChangeFilter = (agentName: string) => {
    if (agentName === "") {
      setSelectedAgentFilter("");
      return;
    }

    const selectedAgent = agentsDropdown.find(
      (branch) => branch.username === agentName
    );
    if (selectedAgent) {
      setSelectedAgentFilter(selectedAgent.id.toString());
    }
  };

  const handleClassChange = async (className: string) => {
    if (className === "") {
      setSelectedClass("");
      return;
    }

    const selectedClass = classesDropdown.find(
      (branch) => branch.name === className
    );
    if (selectedClass) {
      setSelectedClass(selectedClass.class_name_id.toString());
    }
  };

  const handleAdmissionStatusChange = async (admission: string) => {
    if (admission === "") {
      setWizklubStudentsSelectedAdmissionStatus("");
      // return;
    }

    const selectedClass = admissonStatusDropdown.find(
      (branch) => branch.admission_status === admission
    );
    if (selectedClass) {
      setWizklubStudentsSelectedAdmissionStatus(
        selectedClass.admission_status_id.toString()
      );
    }
  };

  const handleAgentChangeFilter1 = async (AgentName: string) => {
    if (AgentName === "") {
      setWizklubSelectedAgent("");
      return;
    }

    const selectedCategory = agentsDropDown.find(
      (subCategory) => subCategory.username === AgentName
    );
    if (selectedCategory) {
      setWizklubSelectedAgent(selectedCategory.id.toString());
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setshowSolidSuccessToast(false);
      setShowSolidDangerToast(false);
    }, 3000);
  }, [toastMessage, dangerToastMessage]);

  const handleBranchChange = (branchName: string) => {
    if (branchName === "") {
      setSelectedBranch("");
      return;
    }

    const selectedBranch = branches.find(
      (branch) => branch.name === branchName
    );
    if (selectedBranch) {
      setSelectedBranch(selectedBranch.branch_id.toString());
    }
  };

  // useEffect(() => {
  //   fetchData(currentPage, pageSize, searchText, selectedBranch, selectedAgentFilter, selectedClass);
  // }, [currentPage, selectedBranch, pageSize]);

  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => {
    setShowSolidDangerToast(false);
  };
  const columns: ColumnsType<any> = [
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_text: any, record: { student_id: any; SCS_Number: any }) => (
    //     <Checkbox
    //       checked={selectedRowKeys.includes(record.student_id)}
    //       onChange={() =>
    //         handleSelect(record.student_id, selectedRowKeys, setSelectedRowKeys)
    //       }
    //     />
    //   ),
    //   key: "action",
    //   align: "center",
    // },
    {
      title: (
        <span>
          SCS Number
          <span>
            {sortConfigs.some(config => config.field === "SCS_Number") && (
              <span style={{ marginLeft: 8 }}>
                {sortConfigs.find(config => config.field === "SCS_Number")?.order === 'ascend' ? (
                  <ArrowUpOutlined style={{ color: '#1890ff' }} />
                ) : (
                  <ArrowDownOutlined style={{ color: '#1890ff' }} />
                )}
              </span>
            )}
            {scsSearchText && (
              <span
                style={{
                  marginLeft: 8,
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <span style={{ color: "#1890ff", marginRight: 4 }}>
                  ({scsSearchText})
                </span>
                <CloseCircleOutlined
                  onClick={() => {
                    setScsSearchText("");
                  }}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </span>
            )}
          </span>
        </span>
      ),
      dataIndex: "SCS_Number",
      key: "SCS_Number",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search SCS Number"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setScsSearchText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      // onFilter: (
      //   value: string,
      //   record: { SCS_Number: { toString: () => string } }
      // ) =>
      //   record.SCS_Number?.toString()
      //     .toLowerCase()
      //     .includes((value as string).toLowerCase()),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { student_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "SCS_Number"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "SCS_Number", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Name
          <span>
            {sortConfigs.some(config => config.field === "name") && (
              <span style={{ marginLeft: 8 }}>
                {sortConfigs.find(config => config.field === "name")?.order === 'ascend' ? (
                  <ArrowUpOutlined style={{ color: '#1890ff' }} />
                ) : (
                  <ArrowDownOutlined style={{ color: '#1890ff' }} />
                )}
              </span>
            )}
            {nameSearchText && (
              <span
                style={{
                  marginLeft: 8,
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <span style={{ color: "#1890ff", marginRight: 4 }}>
                  ({nameSearchText})
                </span>
                <CloseCircleOutlined
                  onClick={() => {
                    setNameText("");
                  }}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </span>
            )}
          </span>
        </span>
      ),
      dataIndex: "name",
      key: "name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search Name"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setNameText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      // // onFilter: (
      //   value: string,
      //   record: { SCS_Number: { toString: () => string } }
      // ) =>
      //   record.SCS_Number?.toString()
      //     .toLowerCase()
      //     .includes((value as string).toLowerCase()),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { no_of_attempts: number; student_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Branch
          {sortConfigs.some(config => config.field === "branch__name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "branch__name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          <span>{selectedBranchName ? ` (${selectedBranchName})` : ""}
            {selectedBranchName && (
              <CloseCircleOutlined
                onClick={() => {
                  setSelectedBranchName(""); // Clear branch on reset
                  handleBranchChange("");
                  // confirm();
                }}
                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
              />
            )}
          </span>
        </span>
      ),
      dataIndex: "branch_name",
      key: "branch_name",
      filters: branches.map((branch) => ({
        text: branch.label,
        value: branch.name,
      })),
      onFilter: (value: any, record: Admin) =>
        record.branch_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Branch"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value) => {
              setSelectedKeys([value]);
              setSelectedBranchName(value);
              handleBranchChange(value); // Include handleBranchChange here
              confirm();
            }}
            value={selectedKeys[0]}
            style={{ width: 200 }}
          >
            {branches.map((branch) => (
              <Option key={branch.branch_id} value={branch.name}>
                {branch.label}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
              handleBranchChange("");
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (_text: any, record: Admin) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "branch__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "branch__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Orientation
          <span>
            {sortConfigs.some(config => config.field === "orientation__name") && (
              <span style={{ marginLeft: 8 }}>
                {sortConfigs.find(config => config.field === "orientation__name")?.order === 'ascend' ? (
                  <ArrowUpOutlined style={{ color: '#1890ff' }} />
                ) : (
                  <ArrowDownOutlined style={{ color: '#1890ff' }} />
                )}
              </span>
            )}
            {selectedOrientation !== 0
              ? ` (${orientationsDropdown.find(
                (state) => state.orientation_id === selectedOrientation
              )?.name
              })`
              : ""}
            {selectedOrientation !== 0 && (
              <CloseCircleOutlined
                onClick={handleClearState}
                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
              />
            )}
          </span>
        </span>
      ),
      dataIndex: "orientation_name",
      key: "orientation_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Orientation"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = orientationsDropdown.find(
                (s) => s.orientation_id === value
              );
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedOrientation(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === "string" &&
              (option.children as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {orientationsDropdown.map((state) => (
              <Select.Option
                key={state.orientation_id}
                value={state.orientation_id}
              >
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { orientation_name: string }) =>
        record.orientation_name === value,
      render: (_text: any, record: Admin) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "orientation__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "orientation__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Previous Orientation
          <span>
            {sortConfigs.some(config => config.field === "previous_orientation__name") && (
              <span style={{ marginLeft: 8 }}>
                {sortConfigs.find(config => config.field === "previous_orientation__name")?.order === 'ascend' ? (
                  <ArrowUpOutlined style={{ color: '#1890ff' }} />
                ) : (
                  <ArrowDownOutlined style={{ color: '#1890ff' }} />
                )}
              </span>
            )}

            {selectedPreviousOrientation !== 0
              ? ` (${orientationsDropdown.find(
                (state) =>
                  state.orientation_id === selectedPreviousOrientation
              )?.name
              })`
              : ""}
            {selectedPreviousOrientation !== 0 && (
              <CloseCircleOutlined
                onClick={handleClearPreviousOrientation}
                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
              />
            )}
          </span>
        </span>
      ),
      dataIndex: "previous_orientation_name",
      key: "previous_orientation_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Previous Orientation"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = orientationsDropdown.find(
                (s) => s.orientation_id === value
              );
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedPreviousOrientation(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === "string" &&
              (option.children as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {orientationsDropdown.map((state) => (
              <Select.Option
                key={state.orientation_id}
                value={state.orientation_id}
              >
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { orientation_name: string }) =>
        record.orientation_name === value,
      render: (_text: any, record: Admin) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "previous_orientation__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "previous_orientation__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Class
          <span>{sortConfigs.some(config => config.field === "student_class__name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student_class__name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}{selectedClassName ? ` (${selectedClassName})` : ""}
            {selectedClassName && (
              <CloseCircleOutlined
                onClick={() => {
                  setSelectedClassName(""); // Clear branch on reset
                  handleClassChange("");
                  // confirm();
                }}
                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
              />
            )}
          </span>
        </span>
      ),
      dataIndex: "student_class_name",
      key: "student_class_name",
      filters: classesDropdown.map((classItem) => ({
        text: classItem.label,
        value: classItem.name,
      })),
      onFilter: (value: any, record: { student_class_name: string | any[] }) =>
        record.student_class_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Class"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value: string) => {
              setSelectedKeys([value]);
              setSelectedClassName(value);
              handleClassChange(value);
              confirm();
            }}
            value={selectedKeys[0] ? String(selectedKeys[0]) : undefined}
            style={{ width: 200 }}
          >
            {classesDropdown.map((classItem) => (
              <Option key={classItem.class_name_id} value={classItem.name}>
                {classItem.label}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters?.(); // optional chaining – clearFilters may be undefined
              confirm();
              handleClassChange("");
              setSelectedClassName(""); // optional: clear external state
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student_class__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student_class__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Admission Status
          {sortConfigs.some(config => config.field === "admission_status__admission_status") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "admission_status__admission_status")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {wizklubStudentsSelectedAdmissionStatusName
            ? `(${wizklubStudentsSelectedAdmissionStatusName})`
            : ""}
          {wizklubStudentsSelectedAdmissionStatusName && (
            <CloseCircleOutlined
              onClick={() => {
                setWizklubStudentsSelectedAdmissionStatusName(""); // Clear branch on reset
                handleAdmissionStatusChange("");
                // confirm();
              }}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "admission_status_name",
      key: "admission_status_name",
      filters: admissonStatusDropdown.map((classItem) => ({
        text: classItem.admission_status_id,
        value: classItem.admission_status,
      })),
      onFilter: (
        value: any,
        record: { admission_status_name: string | any[] }
      ) => record.admission_status_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Status"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value: string) => {
              setSelectedKeys([value]);
              setWizklubStudentsSelectedAdmissionStatusName(value);
              handleAdmissionStatusChange(value);
              confirm();
            }}
            value={selectedKeys[0] ? String(selectedKeys[0]) : undefined}
            style={{ width: 200 }}
          >
            {admissonStatusDropdown.map((item) => (
              <Option key={item.admission_status_id} value={item.admission_status}>
                {item.admission_status}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters?.(); // optional chaining – clearFilters may be undefined
              confirm();
              handleAdmissionStatusChange("");
              setWizklubStudentsSelectedAdmissionStatusName(""); // optional: clear external state
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "admission_status__admission_status"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "admission_status__admission_status", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Is PO Attended
          {sortConfigs.some(config => config.field === "student__is_po_attended") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__is_po_attended")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {selectedIsPOAttended !== "" && (
            <>
              {`${selectedIsPOAttended ? ' (Yes)' : ' (No)'}`}
              <CloseCircleOutlined
                onClick={handleClearIsPOAttended}
                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
              />
            </>
          )}
        </span>
      ),
      dataIndex: "is_po_attended",
      key: "is_po_attended",
      render: (value: boolean) => (value ? "Yes" : "No"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            placeholder="Is PO Attended"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              setSelectedKeys([value]);
              setSelectedIsPOAttended(value); // <-- Updated state handler
              confirm();
            }}
            allowClear
          >
            <Select.Option value={true}>Yes</Select.Option>
            <Select.Option value={false}>No</Select.Option>
          </Select>
        </div>
      ),
      // onFilter: (value: boolean, record: { is_last_year_paid: boolean }) =>
      //   record.is_last_year_paid === value,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__is_po_attended"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__is_po_attended", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Agent
          {sortConfigs.some(config => config.field === "wizklub_agent__username") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "wizklub_agent__username")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {selectedAgentFilter1 !== 0
            ? ` (${agents.find((agent) => agent.id === selectedAgentFilter1)
              ?.username
            })`
            : ""}
          {selectedAgentFilter1 !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearAgent}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "wizklub_agent_name",
      key: "wizklub_agent_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Agent"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = agents.find((b) => b.username === value);
              setSelectedKeys(selected ? [selected.username] : []);
              setSelectedAgentFilter1(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === "string" &&
              (option.children as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {agents.map((branch) => (
              <Select.Option key={branch.id} value={branch.id}>
                {branch.username}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { wizklub_agent_name: string }) =>
        record.wizklub_agent_name === value,
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "wizklub_agent__username"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "wizklub_agent__username", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    // {
    //   title: (
    //     <span>
    //       Student Tag
    //       {selectedStudentTag !== 0
    //         ? ` (${studentTags.find(
    //           (state) => state.id === selectedStudentTag
    //         )?.name
    //         })`
    //         : ""}
    //       {selectedStudentTag !== 0 && (
    //         <CloseCircleOutlined
    //           onClick={handleClearStudentTag}
    //           style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
    //         />
    //       )}
    //     </span>
    //   ),
    //   dataIndex: "student_tag_names",
    //   key: "student_tag_names",
    //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
    //     <div style={{ padding: 8 }}>
    //       <Select
    //         showSearch
    //         placeholder="Select student tag"
    //         style={{ width: 188 }}
    //         value={selectedKeys[0]}
    //         onChange={(value) => {
    //           const selected = studentTags.find(
    //             (s) => s.id === value
    //           );
    //           setSelectedKeys(selected ? [selected.name] : []);
    //           setSelectedStudentTag(value);
    //           confirm();
    //         }}
    //         allowClear
    //         filterOption={(input, option) =>
    //           typeof option?.children === "string" &&
    //           (option.children as string)
    //             .toLowerCase()
    //             .includes(input.toLowerCase())
    //         }
    //       >
    //         {studentTags.map((state) => (
    //           <Select.Option
    //             key={state.id}
    //             value={state.id}
    //           >
    //             {state.name}
    //           </Select.Option>
    //         ))}
    //       </Select>
    //     </div>
    //   ),
    //   onFilter: (value: any, record: { department_name: string }) =>
    //     record.department_name === value,
    //   render: (
    //     _text: any,
    //     record: { student_id: any; no_of_attempts: number }
    //   ) => (
    //     <Link
    //       to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=1`}
    //     >
    //       {_text}
    //     </Link>
    //   ),
    // },
  ];

  const Preloader = () => {
    return (
      <div id="global-loader">
        <div className="page-loader"></div>
      </div>
    );
  };

  useEffect(() => {
    console.log(selectedRowKeys);
  }, [selectedRowKeys]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Wizklub Students Data</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard1}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Students Data
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap"></div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Students List</h4>

              <div className="d-flex align-items-center flex-wrap ms-auto">
                {/* <Checkbox
                  indeterminate={
                    selectedRowKeys.length > 0 &&
                    selectedRowKeys.length < admin.length
                  }
                  checked={selectedRowKeys.length === admin.length}
                  onChange={(e) =>
                    handleSelectAll(e, admin, setSelectedRowKeys)
                  }
                >
                  Select All
                </Checkbox> */}
                {/* {checkPermission("change_agent", "Records") && (
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px" }}
                  >
                    Change Agent
                  </button>
                )} */}

                {/* {checkPermission(
                  "assign_agent_targets",
                  "Records"
                ) && (
                  <button
                    className="btn btn-primary"
                    onClick={() => setAsignShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px" }}
                  >
                    Assign Agent
                  </button>
                )} */}
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onKeyDown={(e) => handleKeyDown(e)}
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <>
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    Selection={false}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      locale: { items_per_page: "" },
                      nextIcon: <span>Next</span>,
                      prevIcon: <span>Prev</span>,
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      total: totalCount,
                      showTotal: (total: any, range: any[]) =>
                        `${range[0]}-${range[1]} of ${total}`,
                    }}
                    onChange={handleTableChange} // Move this outside of pagination
                    onSearch={handleSearch}
                    searchText={searchText}
                  />
                </>
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {showCard && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1049,
              }}
            />
            <div
              className="card"
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "20%",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                borderRadius: "10px",
                zIndex: 1050,
                backgroundColor: "#f9f9f9",
                padding: "20px",
              }}
            >
              {/* <div className="card-header">
                <h4
                  className="modal-title"
                  style={{
                    color: "#333",
                    marginBottom: "15px",
                  }}
                >
                  Change Agent
                </h4>
              </div> */}
              <form onSubmit={handleAgentChange}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Select Agent
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                            value={selectedAgent}
                            onChange={(value) => setSelectedAgent(value)}
                            style={{
                              width: "100%",
                            }}
                            showSearch
                            filterOption={(input, option) => {
                              if (!option || !option.children) return false; // Check if option or option.children is undefined
                              const label =
                                option.children as unknown as string; // Ensure that option.children is treated as a string
                              return label
                                .toLowerCase()
                                .includes(input.toLowerCase());
                            }}
                          >
                            {agentsDropdown.map((agent) => (
                              <Option key={agent.id} value={agent.id}>
                                {agent.username}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    onClick={() => setShowCard(false)}
                  >
                    Cancel
                  </Button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={agentsLoading}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
        {AsignshowCard && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1049,
              }}
            />
            <div
              className="card"
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "20%",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                borderRadius: "10px",
                zIndex: 1050,
                backgroundColor: "#f9f9f9",
                padding: "20px",
              }}
            >
              <form onSubmit={handleAgentAssignment}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Select Agent
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                            value={selectedAgent}
                            onChange={(value) => setSelectedAgent(value)}
                            style={{
                              width: "100%",
                            }}
                            showSearch
                            filterOption={(input, option) => {
                              if (!option || !option.children) return false; // Check if option or option.children is undefined
                              const label =
                                option.children as unknown as string; // Ensure that option.children is treated as a string
                              return label
                                .toLowerCase()
                                .includes(input.toLowerCase());
                            }}
                          >
                            {agentsDropdown.map((agent) => (
                              <Option key={agent.id} value={agent.id}>
                                {agent.username}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </div>
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Target Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={targetDate}
                          onChange={(e) => setTargetDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    onClick={() => setAsignShowCard(false)}
                  >
                    Cancel
                  </Button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={agentsLoading}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </>
        )}

        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}

        <Toast
          show={showSolidSuccessToast}
          onClose={handleSolidSuccessToastClose}
          id="solidSuccessToast"
          className="colored-toast bg-success text-fixed-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 1050,
          }}
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>

        <Toast
          show={showSolidDangerToast}
          onClose={handleSolidDangerToastClose}
          id="solidDangerToast"
          className="colored-toast bg-danger text-fixed-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 1050,
          }}
        >
          <Toast.Body>{dangerToastMessage}</Toast.Body>
        </Toast>
      </>
    </div>
  );
};

export default WizklubStudents;
